import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://allchinabuyspreadsheet.fit';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-4">
            FAQ
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            AllChinaBuy Spreadsheet FAQ
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            Everything you need to know about using the AllChinaBuy spreadsheet to find trusted products and verified sellers.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-150"
                aria-expanded={openIndex === idx}
              >
                <h4 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <i
                    className={`text-base text-foreground-400 transition-transform duration-200 ${
                      openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            '@id': `${SITE_URL}/#faq`,
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}